<template>
  <div class="recommended search-pod has-h-100 has-p-3 has-bg-gray-0 is-rounded-2">
    <div class="row">
      <div class="col">
        <h2 class="is-h5 has-mb-3 has-mt-0 has-text-primary">
          <a :href="link" :title="heading">{{ heading }}</a>
        </h2>
        <div class="search-debug">DEBUG | Category: {{ category }} | CategoryRank: {{ categoryRank }} | Importance: {{ importance }}</div>
      </div>
    </div>
    <div class="row no-gutters">
      <div class="col-xs-4 col-sm-12 col-md-3">
        <div class="aspect-ratio-container is-4x3 is-d-block has-mb-2 is-rounded-1" style="overflow: hidden;">
          <div class="aspect-ratio-content">            
            <a :href="link" v-if="isIcon"><i :class="`search-pod__icon ${icon}`"></i></a>
            <a :href="link" :title="heading" v-if="!isIcon" class="recommended__img-block"><img class="media-cover is-rounded-1" :src="`${image}?anchor=center&mode=crop&quality=80&width=800`" alt="" /></a>
          </div>
        </div>
      </div>
      <div class="col-xs-8 col-sm-12 col-md-9">
        <p class="search-pod__text has-pl-xs-2 has-pl-sm-0 has-pl-md-4 has-text-text has-mb-2 has-mt-xs-0 has-mt-sm-4 has-mt-md-0">
          {{ text.substring(0, 180) }}&hellip;&nbsp;<a :href="link" class="search-pod__link" title="Read more">&raquo;<span class="screen-reader-only">Read more on {{ heading }}</span></a>
        </p>
      </div>
      <div class="col-12" v-if="tags.length > 0 && tags[0].trim() !== ''">
        <p class="has-mb-0 has-mt-0">
          <template v-for="(item, index) in tags">
            <a href="#" @click="onClick(item.trim())" class="hashtag" :key="`hashtag-${index}`">#{{item.trim()}}</a>
          </template>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RecommendedCard",
  props:{
    heading: String,
    image: String,
    text: String,
    link: String,    
    tags: Array,
    icon: String,
    category: String,
    categoryRank: Number,
    importance: Number,
  },
  data: function () {
    return {
      comparisonImageURL: "/Dist/images/logo-square.svg",
    }
  },
  computed: {
    isIcon: function() {
      return this.icon !== undefined && this.icon !== "" && this.image.indexOf(this.comparisonImageURL) > -1;
    }
  },
  methods:{
    onClick(q){
      this.$store.commit('setSearchTerm', q);
    }
  }
}
</script>

<style>
  .search-pod__icon {
    background: var(--color-brand-base);
    color: #fff;
    font-size: 3em;
    display: block;
    text-align: center;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
</style>